<div
  class="text-label"
  [style.font-size]="props['fontSize'] || '1rem'"
  [style.font-weight]="props['fontWeight'] || 'normal'"
  [style.color]="props['color'] || '#333'"
  [style.text-align]="props['textAlign'] || 'left'"
  aria-hidden="true"
  [innerHTML]="
    props['content'] || ''
      | templateMetadata: $safeNavigationMigration(formState?.templateContext)
      | markdown
  "
></div>
